import { render } from "./ConfirmPassword.vue?vue&type=template&id=475ae21d"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "475ae21d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('475ae21d', script)) {
    api.reload('475ae21d', script)
  }
  
  module.hot.accept("./ConfirmPassword.vue?vue&type=template&id=475ae21d", () => {
    api.rerender('475ae21d', render)
  })

}

script.__file = "resources/js/Pages/Auth/ConfirmPassword.vue"

export default script